<template>
  <div
    class="d-flex"
    v-if="departure"
  >
    <div>
      <figure
        class="departure-poster"
        v-if="image"
      >
        <img
          :src="'/api/images/departures/' + departure.img"
          class="departure-poster-img"
          @error="image = false"
        >
      </figure>
    </div>
    <div class="departure-desc w-100">
      <div
        class="txt-center pt-3"
        v-if="cancellation"
      >
        <div class="pill pill-black">
          <p class="px-3 py-1">
            Reserva cancelada el {{ cancellation.date.toLocaleDateString() }}.<br>El
            gasto por cancelacion hasta {{ cancellation.days }} dias antes de la salida
            es
            <strong>{{ cancellation.total }}</strong>
          </p>
        </div>
        <hr class="mt-3">
      </div>
      <h3 class="departure-desc-title">
        DETALLES DEL PAQUETE
      </h3>
      <div>
        <span v-if="departure.duration">{{ departure.duration }}</span> /
        <span v-if="departure.amenity">{{ departure.amenity }}</span>
      </div>
      <p v-if="departure.description">
        {{ departure.description }}
      </p>
      <p v-if="departure.boardings">
        LUGARES DE EMBARQUE: {{ departure.boardings.map(a => a.name).join(', ') }}
      </p>
      <div class="ml-n2">
        <a
          href="#"
          class="btn btn-link"
          @click="$emit('close')"
        >CERRAR</a>
        <a
          href="#"
          class="btn btn-link"
          v-if="['finalized', 'acredited'].includes(reservation.status) && !cancellation"
          @click="cancel(reservation.id)"
        >
          CANCELAR RESERVA
        </a>
        <a
          :href="
            '/payments?code=' +
              reservation.id +
              '&amount=' +
              reservation.price.final +
              '&agency=' +
              $store.state.user.email
          "
          class="btn btn-link txt-orange"
        >
          PAGO ONLINE
        </a>
        <a
          class="btn btn-link"
          v-if="reservation.voucher"
          :href="reservation.voucher || '#'"
          target="_blank"
        >
          VOUCHER
        </a>
        <a
          class="btn btn-link"
          :href="
            $router.resolve({ name: 'departure', params: { id: departure.id } }).href
          "
        >
          VOLVER A RESERVAR
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import Btn from '@/components/Btn'
import { API_ENDPOINT_BASE } from '@/constans'
import { LOADING } from '@/store/mutations'
import axios from 'axios'
import swal from 'sweetalert2'

export default {
  components: { Btn },

  props: ['reservation'],

  data () {
    return {
      image: !!this.reservation.departure.img
    }
  },

  methods: {
    cancel (id) {
      swal({
        title: 'Cancelar reserva.',
        text: 'Esta seguro de cancelar la reserva ?',
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: 'Si',
        cancelButtonText: 'No'
      }).then(({ value }) => {
        if (value) {
          this.$store.commit(LOADING, true)
          axios
            .post(API_ENDPOINT_BASE + '/reservations/' + id + '/cancel')
            .then(response => {
              swal({
                html: response.data.details,
                type: 'success',
                onClose: () => window.location.reload()
              })
            })
            .catch(error => {
              swal({ html: error.response.data.msg, type: 'error' })
            })
            .finally(() => this.$store.commit(LOADING, false))
        }
      })
    }
  },

  computed: {
    departure () {
      return this.reservation.departure
    },
    cancellation () {
      let cancellation = null

      if (this.reservation.cancellation) {
        const date = new Date(this.reservation.cancellation.date_time)
        cancellation = {
          date,
          days: Math.ceil(
            Math.abs(new Date(this.departure.date_departure) - date) /
							(1000 * 60 * 60 * 24)
          ),
          total: this.reservation.price.currency + this.reservation.cancellation.price
        }
      }

      return cancellation
    }
  }
}
</script>
